"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LineThicknessThick = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LineThicknessThick_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 8,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.342 1.83a1.5 1.5 0 0 0-2.013-.671l-.012.006-.154.081-.012.007a10.313 10.313 0 0 0-1.61 1.095C5.74 3.012 4.5 4.278 4.5 6c0 .508.1 1.038.397 1.515.306.49.734.79 1.15.963.658.275 1.42.273 1.845.272H8c.17 0 .308.001.425.005-.06.142-.155.322-.299.538-.298.448-.723.932-1.188 1.396a19.43 19.43 0 0 1-1.69 1.496l-.156.12A1.5 1.5 0 0 0 6.9 14.7l.006-.004.186-.144.007-.005A22.38 22.38 0 0 0 9.06 12.81c.535-.536 1.11-1.177 1.562-1.854.425-.637.877-1.506.877-2.457 0-.508-.102-1.038-.398-1.515a2.436 2.436 0 0 0-1.15-.963c-.658-.275-1.419-.273-1.844-.272H8c-.18 0-.324-.001-.445-.005.108-.28.385-.66.905-1.093a7.315 7.315 0 0 1 1.126-.765l.099-.053a1.5 1.5 0 0 0 .657-2.005Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LineThicknessThick_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LineThicknessThick;
exports["default"] = _default;